// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Folder40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Folder40Filled: FC<Folder40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M6.111 33.334c-.75 0-1.4-.28-1.951-.84-.551-.56-.827-1.207-.827-1.938V9.445c0-.732.276-1.378.827-1.938.55-.56 1.201-.84 1.951-.84H17.25l2.778 2.778h13.86c.732 0 1.378.28 1.938.84.56.56.84 1.206.84 1.937v18.334c0 .731-.28 1.377-.84 1.937-.56.56-1.206.84-1.937.84H6.11Z" />
        </svg>
    );
};

export default Folder40Filled;
